// components/NewUi/TreatmentFlow/AddTreatmentID.jsx
import React, { useState } from "react";
import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; 
import styles from "./flow.module.scss";

export default function AddTreatmentID({ onNext, onBack, setTreatmentData, user, setBannerMessage }) {
  const [value, setValue] = useState("");
  const [localError, setLocalError] = useState(""); 
  const queryClient = useQueryClient();
  const navigate = useNavigate();

const createConsent = useMutation({
  mutationFn: ({ id, mode }) =>
    axios.post(`/consent_bundle/submit_treatment_plan_for_consent_bundle_creation`, { id, mode }),
  onSuccess: (data) => {
    setLocalError("");

    if (data?.data?.error === "Failed to create consent bundle") {
      toast.error("Failed to create consent bundle. Please check the treatment ID and try again.");
      setLocalError("Failed to create consent bundle. Please check the treatment ID and try again.");
      return;
    }
    const bundle = data?.data;
    if (
    bundle?.status === "Sent For Signing" ||
    bundle?.status === "Completed" ||
    bundle?.status === "Expired" ||
    bundle?.status === "Archived"
  ) {
    const bundleId = bundle?.id;
    toast.info(`Consent bundle is ${bundle?.status}. Redirecting...`);
    navigate(`/summary-new/${bundleId}`);
    return;
  }

    // default behavior
    setTreatmentData(bundle);
    queryClient.invalidateQueries({ queryKey: ["patients"] });
    onNext();
  },
  onError: (error) => {
    console.log("Error response status:", error?.response?.status);
    console.log("Error details:", error?.response?.data);

    if (error?.response?.data?.error === "Failed to create consent bundle") {
      toast.error("Failed to create consent bundle. Please check the treatment ID and try again.");
      setLocalError("Failed to create consent bundle. Please check the treatment ID and try again.");
      return;
    }

    console.log("Error response status:", user);
    if (error?.response?.status === 400) {
      toast.error("No Active Subscription Found");
      let message = "";
      if (user === 1) {
        message =
          error?.response?.data?.detail === "User Not Under Subscription"
            ? "Your subscription plan is inactive. Please contact your administrator to purchase a new plan. <a href='/plans'> Go to Plans Page</a>"
            : "Your subscription plan is expired. Please visit the <a href='/plans'>Plans Page</a> to purchase a new plan.";
      } else if (user === 2) {
        message =
          error?.response?.data?.detail === "User Not Under Subscription"
            ? "User Not Under Subscription. Please contact your administrator or visit the <a href='/plans'>Plans Page</a> to purchase a new plan as an Associate Dentist."
            : "Your practice subscription plan is expired. Please visit the <a href='/plans'>Plans Page</a> to purchase a new plan as an Associate Dentist.";
      } else if (user === 3 || user === 4) {
        message =
          error?.response?.data?.detail === "expired"
            ? "Your practice subscription plan is expired. Please visit the <a href='/my-plan'>My Plans Page</a> to renew the subscription."
            : "User Not Under Subscription. Please contact your administrator or visit the <a href='/my-plan'>My Plans Page</a> to renew the subscription.";
      }
      setBannerMessage(message);
    } else {
      toast.error("Something went wrong. Please try again later.");
      console.error(error);
    }
  },
});


  const handleChange = (e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) setValue(val);
  };

  const handleNext = () => {
    if (!value.trim()) return;
    setLocalError("");
    createConsent.mutate({ id: value.trim(), mode: "consent_bundle" });
  };

  return (
    <div className={styles.container}>
      {createConsent.isPending && (
        <div className={styles.overlayLoader}>
          <div className={styles.spinner}></div>
          <p>Creating consent bundle...</p>
        </div>
      )}

      {/* 🔹 Inline Card Wrapper */}
      <div className={styles.inlineCard}>
        <div className={styles.fieldLabel}>Treatment ID</div>
        <input
          className={styles.input}
          type="text"
          placeholder="Enter treatment number"
          value={value}
          onChange={handleChange}
        />

        {/* 🔹 Inline error message */}
        {localError && <p className={styles.errorText}>{localError}</p>}

        <div className={styles.actions}>
          <button className={styles.btnOutline} onClick={onBack}>
            Cancel
          </button>

          <button
            className={`${styles.btnPrimary} ${!value.trim() ? styles.disabled : ""}`}
            onClick={handleNext}
            disabled={!value.trim() || createConsent.isPending}
          >
            {createConsent.isPending ? (
              <div className={styles.loaderWrapper}>
                <div className={styles.loader}></div>
                <span>Processing...</span>
              </div>
            ) : (
              "Next"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
